import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-loader-screen',
    imports: [],
    templateUrl: './loader-screen.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './loader-screen.component.scss'
})
export class LoaderScreenComponent {
}
